import React from 'react';

import Images from '@dashboard/components/Formik/components/Images';
import usePage from '@dashboard/hooks/usePage';

const EventMediaForm = () => {
  const { page, attachImage, detachImage, updatePage } = usePage();

  return (
    <Images
      media={page.images}
      onAttach={fileId => attachImage.mutateAsync(fileId)}
      onDetach={fileId => detachImage.mutateAsync(fileId)}
      onReorder={images => updatePage.mutateAsync({ images })}
    />
  );
};

export default EventMediaForm;
